/** What the API tells a setup guide (`setup` on the agent and connections endpoints). */
export interface AgentSetup {
  server: string;
  apiBase: string;
  tokenEndpoint: string;
  /** GitHub repository that hosts the Claude Code plugin marketplace. */
  marketplace: string;
  instructions: string;
}

export type AgentSetupMode =
  { kind: 'personal' } | { kind: 'headless'; agentName: string; clientId?: string | undefined };

/** The server the plugin uses when none is given. */
export const DEFAULT_SERVER = 'https://jira.lixionary.com';

/**
 * Copyable setup for the lixionary-jira Claude Code plugin. Personal agents install the plugin and sign in
 * through the browser; headless agents run the plugin's CLI with client credentials from the environment.
 * Secrets are never embedded.
 */
export function agentSetupCommands(setup: AgentSetup, mode: AgentSetupMode): string {
  if (mode.kind === 'personal')
    return [
      `/plugin marketplace add ${setup.marketplace}`,
      '/plugin install lixionary-jira@lixionary',
      `/lixionary-jira:login${setup.server === DEFAULT_SERVER ? '' : ` ${setup.server}`}`,
    ].join('\n');
  return [
    `# Headless agent "${mode.agentName}". Keep the secret in your CI secret store; never print, log or commit it.`,
    `export LIXIONARY_JIRA_URL=${setup.server}`,
    `export LIXIONARY_JIRA_CLIENT_ID=${mode.clientId ?? '<client ID>'}`,
    'export LIXIONARY_JIRA_CLIENT_SECRET=<client secret>',
    'lixionary-jira status   # or: node plugins/lixionary-jira/lib/lixionary-jira.cjs status',
  ].join('\n');
}
